import InstitutionPharmacyChangeDependOnStatus from "./InstitutionPharmacyChangeDependOnStatus";

export default [ InstitutionPharmacyChangeDependOnStatus ]